import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export type Theme = "dark" | "light";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

/**
 * "dark" dan boshqa har qanday qiymat "light" ga tushadi. Shu bilan birga eski
 * build'lar yozib qo'ygan bo'lishi mumkin bo'lgan "system" qiymati ko'chiriladi.
 */
const normalize = (value: unknown): Theme => (value === "dark" ? "dark" : "light");

export const useThemeStore = create<ThemeState>()(
  devtools(
    persist(
      (set, get) => ({
        theme: "light",
        setTheme: (theme: Theme) => set({ theme: normalize(theme) }),
        toggleTheme: () => set({ theme: get().theme === "dark" ? "light" : "dark" }),
      }),
      {
        name: "theme",
        storage: createJSONStorage(() => localStorage),
        partialize: state => ({ theme: state.theme }),
        migrate: (persisted: unknown) => ({
          theme: normalize((persisted as { theme?: unknown } | null)?.theme),
        }),
      },
    ),
    { name: "Theme Store" },
  ),
);

export const setTheme = (theme: Theme) => useThemeStore.getState().setTheme(theme);
export const toggleTheme = () => useThemeStore.getState().toggleTheme();
